import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import lock from "../../assets/img/lock.svg";
import carbrand from "../../assets/img/carshonda.jpg";
import appstore from "../../assets/img/appstore.png";
import googleplay from "../../assets/img/googleplay.png";
import speedometer from "../../assets/img/speedometer.svg";
import gasolinePump from "../../assets/img/gasoline-pump.svg";
import car from "../../assets/img/car.svg";
import book from "../../assets/img/book.svg";
import barcode from "../../assets/img/barcode.svg";
import tag from "../../assets/img/tag.svg";
import Path from "../../assets/img/Path.svg";
import transmission from "../../assets/img/manual-transmission.svg";
import drivetrain from "../../assets/img/drivetrain.svg";
import cars01 from "../../assets/img/cars01.png";
import carshonda from "../../assets/img/carshonda.jpg";
import persent from "../../assets/img/persent.svg";
import { CopyToClipboard } from "react-copy-to-clipboard";
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Component/Loading/Loading";
import UrCarAction from "../UrCar/UrCarAction";
import Barcode from "react-barcode";
import PageNotFound from "../FallBackUI/PageNotFound";
import CommonPopup from "../../Component/CommonPopup/CommonPopup";
import Delete from "../UrCardetails/Delete";
import Popup from "../../Component/Popup/Popup";
import miles from "../../assets/img/miles.jpg";
import ls from "local-storage";
import { CountContext } from "../Context/Allcontext";

const EditDetails = (props) => {
  const { backURL, id, sellerId, value } = props.location.state;

  const { handleCarCount } = useContext(CountContext) || {};

  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [carDetail, setCarDetail] = useState([]);
  const [lrgImg, setLrgImg] = useState("");
  const [distance, setDistance] = useState("");
  const [copied, setCopied] = useState(false);
  // const { id } = useParams();
  const [copySuccess, setCopySuccess] = useState("");
  const [selectDays, setSelectDays] = useState("");
  const [message, setMessage] = useState(null);
  const [sellAmount, setSellAmount] = useState(null);
  const [sellitError, setSellItError] = useState("");
  const [daysError, setDaysError] = useState("");
  const sellerData = useSelector((state) => state.LoginReducer.payload);
  const dispatch = useDispatch();
  const [isShown, setIsShown] = useState(false);
  const [lrgVideo, setLrgVideo] = useState("");
  const [isVideoFlag, setIsVideoFlag] = useState(false);
  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");
  const [deleteCar, setDeleteCar] = useState(false);
  const sellerStandingStatus = ls.get("sellerStandingStatus");
  const [privilegeDetails, setPrivilegeDetails] = useState("");
  const [changesFlag, setChangesFlag] = useState("no");
  const [changesArray, setChangesArray] = useState([]);
  console.log("changesArray", changesArray);
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  // const redirectpage=(pathid,seller_data)=>{
  //     dispatch(UrCarAction.sellerid(seller_data))
  //     history.push("/inactivecar/"+pathid);
  // 	// history.push({
  // 	// 	pathname: "/cardetails/"+pathid,
  // 	// 	state: {backURL:"/carlist"},
  // 	// 	});
  //   }
  function EditDetailList() {
    console.log("reruncar interval");
    const request = {
      car_id: id,
      seller_dealer_id: sellerId ? sellerId : sellerData.seller_dealer_id,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    };
    console.log("request for car detail", request);
    API.post("carDetails/condition", request)
      .then((res) => {
        console.log("response", res.data.data);
        console.log("Response data", res.data.data);
        if (res.data.success === true) {
          let merged = [];

          for (let i = 0; i < res.data.data.length; i++) {
            merged.push({
              ...res.data.data[i],
              ...res.data.data1.find(
                (item) => item.car_id === res.data.data[i].car_id
              ),
            });
          }
          console.log("merged", merged);
          setCarDetail(merged);
          console.log("setCarDetail", res.data.data1);
          setDistance(res.data.distance);
          setLrgImg(res.data.data[0].image);
          setLrgVideo(res.data.data[0]?.image);
          setIsVideoFlag(false);
          setLoading(false);
        } else {
          setErrors(res.data.error);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
          setLoading(false);
        }
      });
  }
  const privileges = (data) => {
    let request = {
      seller_dealer_id: sellerId ? sellerId : sellerData.seller_dealer_id,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    };
    API.post("sellerPrivileges/condition", request)
      .then((response) => {
        console.log("privilege", response.data.data[0]);
        if (response.data.success === true) {
          setPrivilegeDetails(response.data.data[0]);
        } else {
          setErrors(response.data.error);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
        }
      });
  };
  function DeleteCar(car_id) {
    console.log("car_id", car_id);
    const request = {
      car_id: id,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    };
    console.log("request for edit detail", request);

    API.post("delete_car/update", request)
      .then((res) => {
        console.log("Delete Response data", res.data.data);
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
        }
      });
  }
  function handleSave(high_bid, max_price, dealer_message) {
    setSellItError("");
    // if(!selectDays){
    // 	setDaysError("Select Days is required");
    // 	return;
    // }
    // if(!sellAmount){
    // 	setSellItError("Sell it Now is required");
    // 	return;
    // }
    if (
      sellAmount !== "" &&
      sellAmount !== null &&
      sellAmount !== undefined &&
      sellAmount < high_bid
    ) {
      setSellItError("Sell it Now must be greater than high bid");
      return;
    } else if (sellAmount !== "" && sellAmount % 50 !== 0) {
      setSellItError("Sell it Now accept only multiples of 50");
      return;
    }
    const request = {
      car_id: id,
      days: !selectDays ? 4 : selectDays,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
      dealer_message: !message ? dealer_message : message,
      max_price: !sellAmount ? max_price : sellAmount,
      valuechanges: changesFlag,
      historylist: changesArray,
    };
    console.log("editDealer_runit", request);
    // return
    API.post("editDealer_runit/update", request)
      .then((res) => {
        console.log("response", res.data.data);
        // redirectpage(carDetail[0].car_id,carDetail[0])
        if (res.data.success === true) {
          togglePopup();
          setPopupTitle("Rerun Car");
          setPopupMsg("Car Successfully Rerun");
          setPopupType("success");
          setPopupActionType("redirect");
          setPopupActionValue("Ok");
          setPopupActionPath("/inactivecar");
          handleCarCount();
        } else {
          setErrors(res.data.error);
          togglePopup();
          setPopupTitle("Something Went wrong");
          setPopupMsg(res.data.error.err);
          setPopupType("error");
          setPopupActionType("close");
          setPopupActionValue("close");
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
        }
      });
  }

  function copytoclipboard(e) {
    document.execCommand("copy");
    e.target.focus();
    setCopySuccess("Copied!");
  }

  function img1Click(img) {
    loadLrgImg(img.target.src);
  }
  function img2Click(img) {
    console.log("values passed", img);
    console.log("Imgfile", img.target.src);
    loadLrgImg(img.target.src);
  }
  function img3Click(img) {
    loadLrgImg(img.target.src);
  }
  function img4Click(img) {
    loadLrgImg(img.target.src);
  }

  function loadLrgImg(img) {
    setLrgImg(img);
  }

  function video1Click(video) {
    largeVideoLoad(video);
    setIsVideoFlag(true);
  }
  function video2Click(video) {
    largeVideoLoad(video);
    setIsVideoFlag(true);
  }

  function video3Click(video) {
    largeVideoLoad(video);
    setIsVideoFlag(true);
  }

  function video4Click(video) {
    largeVideoLoad(video);
    setIsVideoFlag(true);
  }

  function largeVideoLoad(video) {
    setLrgVideo(video);
  }

  const numberPattern = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setSellAmount(value);
    setChangesFlag("yes");
    const newValue = value;
    const oldvalue = "";
    const existingChangeIndex = changesArray.findIndex(
      (change) => change.name === "Sell it Now"
    );
    if (existingChangeIndex !== -1) {
      const updatedChangesArray = [...changesArray];
      updatedChangesArray[existingChangeIndex] = {
        oldvalue: oldvalue,
        newvalue: newValue,
        name: "Sell it Now",
      };
      setChangesArray(updatedChangesArray);
    } else {
      const change = {
        oldvalue: oldvalue,
        newvalue: newValue,
        name: "Sell it Now",
      };
      setChangesArray([...changesArray, change]);
    }
  };
  useEffect(() => {
    console.log("id value", id);
    let intervalId;
    intervalId = setInterval(() => {
      EditDetailList();
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);
  useEffect(() => {
    console.log("id value", id);
    EditDetailList();
    DeleteCar();
    privileges();
  }, []);
  const config = {
    background: "#f5f5f5",
    displayValue: false,
    marginTop: "20px",
    marginBottom: "20px",
    fontOptions: "italic",
    width: 2,
    heigth: 5,
  };

  const toggleApprove = () => {
    toggleApproveDelete();
  };

  const toggleApproveDelete = () => {
    setDeleteCar(!deleteCar);
  };

  const getAddSellerPrivileges = () => {
    togglePopup();
    setPopupMsg("Seller doesn't have Remove Car Privilege");
    setPopupActionType("close");
    setPopupActionValue("ok");
  };
  const handleDays = (e) => {
    setChangesFlag("yes");
    const newValue = e.target.value;
    const oldvalue = "";
    setSelectDays(newValue);
    const existingChangeIndex = changesArray.findIndex(
      (change) => change.name === "Days"
    );
    if (existingChangeIndex !== -1) {
      const updatedChangesArray = [...changesArray];
      updatedChangesArray[existingChangeIndex] = {
        oldvalue: oldvalue,
        newvalue: newValue,
        name: "Days",
      };
      setChangesArray(updatedChangesArray);
    } else {
      const change = { oldvalue: oldvalue, newvalue: newValue, name: "Days" };
      setChangesArray([...changesArray, change]);
    }
  };
  const handleMessage = (e) => {
    setChangesFlag("yes");
    const newValue = e.target.value;

    const oldvalue = "";
    setMessage(newValue);
    const existingChangeIndex = changesArray.findIndex(
      (change) => change.name === "Message From The Dealer"
    );
    if (existingChangeIndex !== -1) {
      const updatedChangesArray = [...changesArray];
      updatedChangesArray[existingChangeIndex] = {
        oldvalue: oldvalue,
        newvalue: newValue,
        name: "Message From The Dealer",
      };
      setChangesArray(updatedChangesArray);
    } else {
      const change = {
        oldvalue: oldvalue,
        newvalue: newValue,
        name: "Message From The Dealer",
      };
      setChangesArray([...changesArray, change]);
    }
  };
  return (
    <main id="main" class="inner-page">
      {loading ? (
        <Loading />
      ) : (
        <div id="products-details" class="products-details">
          {errorFlag === true ? (
            <PageNotFound error={errors} />
          ) : (
            <div class="container-fluid inner-page-space">
              <div class="back-btn">
                <a
                  class="back-btn-primary"
                  onClick={() => {
                    history.push(backURL);
                    localStorage.setItem("carStatus", value);
                  }}
                >
                  <i class="bx bx-chevron-left"></i> Back{" "}
                </a>
              </div>
              <div class="row">
                {carDetail.length > 0 && (
                  <div class="col-lg-6">
                    <div class="vehicle-detail-banner banner-content clearfix">
                      <div class="banner-slider">
                        <div class="slider slider-for">
                          <div class="slider-banner-image">
                            {isVideoFlag === false ? (
                              <img
                                src={lrgImg}
                                alt="no image"
                                width={"390px"}
                                height={"470px"}
                              />
                            ) : (
                              <video
                                key={lrgVideo}
                                autobuffer
                                autoPlay
                                controls
                                width={"390px"}
                                height={"470px"}
                              >
                                <source
                                  className="card-img-top"
                                  src={lrgVideo}
                                  type="video/mp4"
                                />
                              </video>
                            )}
                          </div>
                        </div>
                        <div class="slider slider-nav thumb-image">
                          {carDetail.length > 1 ? (
                            <div class="thumbnail-image">
                              <div class="thumbImg">
                                {carDetail[1]?.format == "video" ? (
                                  <video
                                    autobuffer
                                    controls
                                    width="100%"
                                    height="100%"
                                    onClick={() => {
                                      video1Click(carDetail[1]?.carimage);
                                    }}
                                  >
                                    <source
                                      id="mp4"
                                      className="card-img-top"
                                      src={carDetail[1]?.carimage}
                                      type="video/mp4"
                                    ></source>
                                  </video>
                                ) : (
                                  <img
                                    src={carDetail[1]?.carimage}
                                    alt=""
                                    onClick={img1Click}
                                    width="100%"
                                    height="100%"
                                  />
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {carDetail.length > 2 ? (
                            <div class="thumbnail-image">
                              <div class="thumbImg">
                                {carDetail[2]?.format == "video" ? (
                                  <video
                                    autobuffer
                                    controls
                                    width="100%"
                                    height="100%"
                                    onClick={() => {
                                      video2Click(carDetail[2]?.carimage);
                                    }}
                                  >
                                    <source
                                      id="mp4"
                                      className="card-img-top"
                                      src={carDetail[2]?.carimage}
                                      type="video/mp4"
                                    ></source>
                                  </video>
                                ) : (
                                  <img
                                    src={carDetail[2]?.carimage}
                                    alt=""
                                    onClick={img2Click}
                                    width="100%"
                                    height="100%"
                                  />
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {carDetail.length > 3 ? (
                            <div class="thumbnail-image">
                              <div class="thumbImg">
                                {carDetail[3]?.format == "video" ? (
                                  <video
                                    autobuffer
                                    controls
                                    width="100%"
                                    height="100%"
                                    onClick={() => {
                                      video3Click(carDetail[3]?.carimage);
                                    }}
                                  >
                                    <source
                                      id="mp4"
                                      className="card-img-top"
                                      src={carDetail[3]?.carimage}
                                      type="video/mp4"
                                    ></source>
                                  </video>
                                ) : (
                                  <img
                                    src={carDetail[3]?.carimage}
                                    alt=""
                                    onClick={img3Click}
                                    width="100%"
                                    height="100%"
                                  />
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {carDetail.length > 4 ? (
                            <div class="thumbnail-image">
                              <div class="thumbImg">
                                {carDetail[4]?.format == "video" ? (
                                  <video
                                    autobuffer
                                    controls
                                    width="100%"
                                    height="100%"
                                    onClick={() => {
                                      video4Click(carDetail[4]?.carimage);
                                    }}
                                  >
                                    <source
                                      id="mp4"
                                      className="card-img-top"
                                      src={carDetail[4]?.carimage}
                                      type="video/mp4"
                                    ></source>
                                  </video>
                                ) : (
                                  <img
                                    src={carDetail[4]?.carimage}
                                    alt=""
                                    onClick={img4Click}
                                    width="100%"
                                    height="100%"
                                  />
                                )}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {carDetail.length > 0 && (
                  <div class="col-lg-6">
                    <div class="product-dtl">
                      <div class="cars-detail-inside">
                        <div class="cars-detail-views">
                          <p class="car-btns">
                            <span className="greytext">Inventory # : </span>{" "}
                            {carDetail[0].car_id}
                          </p>
                        </div>
                      </div>
                      <div class="product-info">
                        <div class="product-name">
                          <p>
                            {carDetail[0].year} {carDetail[0].make}{" "}
                            {carDetail[0].model}
                          </p>
                        </div>
                        <div class="km-petrol">
                          <p class="details">
                            <img src={speedometer} alt="" />
                            <span>
                              {carDetail[0].mileage}{" "}
                              {carDetail[0]?.mileage_type}
                            </span>
                          </p>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          {carDetail[0].fuel_type == "null" ||
                          carDetail[0].fuel_type == "" ||
                          carDetail[0].fuel_type == null ||
                          carDetail[0].fuel_type == undefined ||
                          carDetail[0].fuel_type == "undefined" ? (
                            ""
                          ) : (
                            <p class="details">
                              <img src={gasolinePump} alt="" />
                              <span>{carDetail[0].fuel_type}</span>
                            </p>
                          )}
                          <a class="labeltype">
                            <span>
                              {carDetail[0].label_type === "Sealed Bid Sales"
                                ? carDetail[0].label_type.substr(0, 10)
                                : carDetail[0].label_type}
                            </span>
                          </a>
                        </div>
                        <p class="odometer">
                          <span className="label">Is Odometer working</span> :{" "}
                          {carDetail[0].odometer}
                        </p>
                      </div>
                      <div class="row vinqr">
                        <div class="col-md-12 carpoints">
                          <div className="label">Vin # : </div>
                          <div class="carpoint">
                            <img src={car} alt="" />
                            <span>{carDetail[0].vin_no}</span>
                            <CopyToClipboard
                              text={carDetail[0].vin_no}
                              onCopy={() => setCopied(true)}
                            >
                              <span
                                title="Copy"
                                onClick={copytoclipboard}
                                className="copyImg"
                              >
                                <i class="icofont-copy"></i>
                              </span>
                            </CopyToClipboard>
                            <img
                              src={barcode}
                              alt=""
                              onMouseEnter={() => setIsShown(true)}
                              onMouseLeave={() => setIsShown(false)}
                            />
                          </div>
                        </div>
                        {isShown && (
                          <div>
                            <Barcode value={carDetail[0].vin_no} {...config} />
                          </div>
                        )}
                      </div>

                      <div class="titlestatus">
                        <h3 className="label">
                          Title status :
                          <span className="tit-sold">
                            {" "}
                            {/* {item.title}</span> */}
                            <div
                              className={`${
                                carDetail[0]?.title === "Title"
                                  ? "title-cart"
                                  : carDetail[0]?.title === "Title Attached"
                                  ? "titleattached-cart"
                                  : carDetail[0]?.title === "Bill of sale only"
                                  ? "billofsale-cart"
                                  : ""
                              }`}
                            >
                              {carDetail[0]?.title}
                            </div>
                          </span>
                        </h3>
                      </div>

                      <div class="editDays">
                        <label htmlFor="no_years">
                          Select number of days to run the car
                        </label>
                        {sellerStandingStatus === 5 ||
                        sellerStandingStatus === 6 ||
                        sellerStandingStatus === 7 ? (
                          <select
                            id="drop"
                            placeholder=""
                            name="dropoption"
                            className="form-control custom-select browser-default textbox"
                            disabled
                          />
                        ) : (
                          <select
                            id="drop"
                            placeholder=""
                            name="dropoption"
                            className="form-control custom-select browser-default textbox"
                            onChange={handleDays}
                          >
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                          </select>
                        )}
                        <p className="form-input-error">{daysError}</p>
                      </div>

                      <div class="editMessage">
                        <label for="address">Message From The Dealer</label>
                        {sellerStandingStatus === 5 ||
                        sellerStandingStatus === 6 ||
                        sellerStandingStatus === 7 ? (
                          <input
                            className="textbox mb-3"
                            class="edittarea"
                            type="text"
                            placeholder=""
                            id="address"
                            name="address"
                            disabled
                          />
                        ) : (
                          <input
                            className="textbox mb-3"
                            class="edittarea"
                            type="text"
                            placeholder=""
                            id="address"
                            name="address"
                            onChange={handleMessage}
                          />
                        )}
                      </div>

                      <div class="minimun-bid">
                        {carDetail[0].sales_type_id == 2 ? (
                          carDetail[0].min_price == "" ||
                          carDetail[0].min_price == undefined ||
                          carDetail[0].min_price == null ||
                          carDetail[0].min_price == 0 ? (
                            ""
                          ) : (
                            <a class="car-btns">
                              Minimum Bid :{" "}
                              <span class="green">
                                {" "}
                                $ {carDetail[0].min_price}
                              </span>
                            </a>
                          )
                        ) : (
                          ""
                        )}
                      </div>
                      <div class="cars-detail-ins">
                        <label for="address">Sell it Now </label>
                        {sellerStandingStatus === 5 ||
                        sellerStandingStatus === 6 ||
                        sellerStandingStatus === 7 ? (
                          <input
                            className="textbox"
                            class="edittarea"
                            type="text"
                            placeholder=""
                            id="address"
                            name="address"
                            disabled
                          />
                        ) : (
                          <input
                            className="textbox "
                            type="text"
                            placeholder=""
                            id="address"
                            name="address"
                            value={sellAmount}
                            onChange={numberPattern}
                          />
                        )}
                        <p className="form-input-error">{sellitError}</p>
                      </div>

                      <div class="custom-button-accept">
                        <div class="cars-buy">
                          <a
                            class={
                              sellerStandingStatus === 5 ||
                              sellerStandingStatus === 6 ||
                              sellerStandingStatus === 7
                                ? "cars-buy-btns greenBtn statuscolor"
                                : "cars-buy-btns greenBtn"
                            }
                            onClick={() =>
                              !(
                                sellerStandingStatus === 5 ||
                                sellerStandingStatus === 6 ||
                                sellerStandingStatus === 7
                              ) &&
                              handleSave(
                                carDetail[0].high_bid,
                                carDetail[0].max_price,
                                carDetail[0].dealer_message
                              )
                            }
                          >
                            Rerun
                          </a>

                          {carDetail[0].deleted_car_status == "yes" ? (
                            <a className="rundeleteBtn">car Deleted</a>
                          ) : (
                            <>
                              {privilegeDetails.remove_car == 1 ? (
                                <a
                                  class={
                                    sellerStandingStatus === 5 ||
                                    sellerStandingStatus === 6 ||
                                    sellerStandingStatus === 7
                                      ? "cars-buy-btns redBtn  statuscolor"
                                      : "cars-buy-btns redBtn"
                                  }
                                  onClick={() =>
                                    !(
                                      sellerStandingStatus === 5 ||
                                      sellerStandingStatus === 6 ||
                                      sellerStandingStatus === 7
                                    ) && toggleApprove()
                                  }
                                >
                                  Delete
                                </a>
                              ) : (
                                <a
                                  class={
                                    sellerStandingStatus === 5 ||
                                    sellerStandingStatus === 6 ||
                                    sellerStandingStatus === 7
                                      ? "cars-buy-btns redBtn  statuscolor"
                                      : "cars-buy-btns redBtn"
                                  }
                                  onClick={() =>
                                    !(
                                      sellerStandingStatus === 5 ||
                                      sellerStandingStatus === 6 ||
                                      sellerStandingStatus === 7
                                    ) && getAddSellerPrivileges()
                                  }
                                >
                                  Delete
                                </a>
                              )}
                            </>
                          )}

                          <a
                            class="cars-buy-btns-primary greyBtn"
                            onClick={() => history.push(backURL)}
                          >
                            Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      <section id="playstoreBlock" class="playstoreBlock">
        <div class="container">
          <div class="row content">
            <div class="col-lg-12">
              <img src={appstore} />
              <img src={googleplay} />
            </div>
          </div>

          {deleteCar && (
            <Popup
              isClose={false}
              content={
                <>
                  <Delete
                    toggle={toggleApproveDelete}
                    carId={id}
                    flag="Delete"
                  />
                </>
              }
              handleClose={toggleApproveDelete}
            />
          )}

          {isOpen && (
            <CommonPopup
              handleClose={togglePopup}
              popupTitle={popupTitle}
              popupMsg={popupMsg}
              popupType={popupType}
              popupActionType={popupActionType}
              popupActionValue={popupActionValue}
              popupActionPath={popupActionPath}
            />
          )}
        </div>
      </section>
    </main>
  );
};
export default EditDetails;
